import alertash from './alertash.gif';
import alertavalanche from './alertavalanche.gif';
import alertcold from './alertcold.gif';
import alertdust from './alertdust.gif';
import alertearthquake from './alertearthquake.gif';
import alertfire from './alertfire.gif';
import alertflood from './alertflood.gif';
import alertfog from './alertfog.gif';
import alertfreeze from './alertfreeze.gif';
import alertfrost from './alertfrost.gif';
import alertgeneric from './alertgeneric.gif';
import alerthazard from './alerthazard.gif';
import alertheat from './alertheat.gif';
import alerthurricane from './alerthurricane.gif';
import alerticy from './alerticy.gif';
import alertpollution from './alertpollution.gif';
import alertsmoke from './alertsmoke.gif';
import alertsnow from './alertsnow.gif';
import alertsurge from './alertsurge.gif';
import alerttornado from './alerttornado.gif';
import alerttropicalstorm from './alerttropicalstorm.gif';
import alerttstorm from './alerttstorm.gif';
import alertvolcano from './alertvolcano.gif';
import alertwindy from './alertwindy.gif';

export const ALERTS_ANIMATED_ICON_PATH_MAP = {
  alertash,
  alertavalanche,
  alertcold,
  alertdust,
  alertearthquake,
  alertfire,
  alertflood,
  alertfog,
  alertfreeze,
  alertfrost,
  alertgeneric,
  alerthazard,
  alertheat,
  alerthurricane,
  alerticy,
  alertpollution,
  alertsmoke,
  alertsnow,
  alertsurge,
  alerttornado,
  alerttropicalstorm,
  alerttstorm,
  alertvolcano,
  alertwindy,
};
